<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="150px">
            <el-form-item label="商品标题：" prop="title">
                <el-input v-model="model.title"></el-input>
            </el-form-item>
            <el-form-item label="商品简介：" prop="ftitle">
                <el-input type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4}"
                    v-model="model.ftitle">
                </el-input>
            </el-form-item>
            <el-form-item label="品牌：" prop="brand">
                <el-input v-model="model.brand"></el-input>
            </el-form-item>
            <el-form-item label="所在分类：" prop="cat_id">
                <!-- <el-cascader
                    v-model="model.cat_id"
                    :options="catTree"></el-cascader> -->
                <el-select clearable v-model="model.cat_id" placeholder="请选择">
                    <el-option v-for="item in catTree" :key="'cat_id'+item.id" :label="item.label" :value="item.id+''"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="图片：" prop="imgpath" class="tipsitem">
                <el-upload
                    list-type="picture-card"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :on-success="handleUploadSuccess"
                    :before-upload="beforeUpload"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :file-list="imgArr"
                    :limit="9">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" :modal="false">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
                <span class="tips">建议尺寸：750px * 750px</span>
            </el-form-item>
            <el-form-item label="图片介绍：" prop="gdesc" class="tipsitem">
                <el-upload
                    list-type="picture-card"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :on-success="handleUploadSuccess1"
                    :before-upload="beforeUpload"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove1"
                    :file-list="imgArr1"
                    :limit="20">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible" :modal="false">
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
                <span class="tips">建议尺寸：750px * 高度不限</span>
            </el-form-item>
            <el-form-item label="视频介绍：" prop="video" v-if="model.video">
                <span>{{model.video}}</span>
                <el-button size="small" type="primary" @click="removeVideo">移除视频</el-button>
            </el-form-item>
            <el-form-item label="视频介绍：" prop="video" class="tipsitem" v-else>
                <el-upload
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="video/mp4"
                    :on-success="handleUploadSuccess2"
                    :before-upload="beforeUploadVideo">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传mp4视频，大小不超过200M</div>
                </el-upload>
            </el-form-item>
            <el-form-item label="分享标题：" prop="share_title">
                <el-input v-model="model.share_title"></el-input>
            </el-form-item>
            <el-form-item label="分享图：" prop="share_img" class="tipsitem">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess3"
                    :before-upload="beforeUpload">
                    <img v-if="model.share_img" :src="model.share_img" class="upImg" style="width: 150px;height: 120px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 150px;height: 120px;line-height: 120px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 400px</span>
            </el-form-item>
            <el-form-item label="分享标题(活动)：" prop="share_title_act">
                <el-input v-model="model.share_title_act"></el-input>
            </el-form-item>
            <el-form-item label="分享图(活动)：" prop="share_img_act" class="tipsitem">
                <el-upload
                    class="img-uploader"
                    name="upFile"
                    :action="uploadAction"
                    :data="uploadData"
                    accept="image/png, image/gif, image/jpg, image/jpeg"
                    :show-file-list="false"
                    :on-success="handleUploadSuccess4"
                    :before-upload="beforeUpload">
                    <img v-if="model.share_img_act" :src="model.share_img_act" class="upImg" style="width: 150px;height: 120px">
                    <i v-else class="el-icon-plus img-uploader-icon" style="width: 150px;height: 120px;line-height: 120px"></i>
                </el-upload>
                <span class="tips">建议尺寸：500px * 400px</span>
            </el-form-item>
            <el-form-item label="销量：" prop="sales">
                <el-input v-model.number="model.sales" style="width: 192.5px"></el-input>
            </el-form-item>
            <el-form-item label="排序：" prop="order_index">
                <el-input v-model.number="model.order_index" style="width: 192.5px"></el-input>
            </el-form-item>
            <el-form-item label="商品标签：" prop="tags">
                <el-input v-model="model.tags"></el-input>
                <span class="tips">例如：Model3;ModelY</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <el-select clearable v-model="model.state" placeholder="请选择">
                    <el-option v-for="item in enuObj('goods_state')" :key="'goodsstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="一级佣金比例(%)：" prop="commission_rate1">
                <el-input v-model.number="model.commission_rate1" style="width: 192.5px"></el-input>
            </el-form-item>
            <el-form-item label="二级佣金比例(%)：" prop="commission_rate2">
                <el-input v-model.number="model.commission_rate2" style="width: 192.5px"></el-input>
            </el-form-item>
            <el-form-item label="三级佣金比例(%)：" prop="commission_rate3">
                <el-input v-model.number="model.commission_rate3" style="width: 192.5px"></el-input>
            </el-form-item>
            <el-form-item label="四级佣金比例(%)：" prop="commission_rate4">
                <el-input v-model.number="model.commission_rate4" style="width: 192.5px"></el-input>
            </el-form-item>
            <el-form-item label="团购佣金比例(%)：" prop="commission_tuan">
                <el-input v-model.number="model.commission_tuan" style="width: 192.5px"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import config from '@/config'
import { saveModel } from '@/api/common'
import { goodsCatData } from '@/api/goodscate'

export default {
    name: 'goodsEdit',
    mixins: [editutil],
    data() {
        return {
            catTree: [],
            model: {
                title: '',
                ftitle: '',
                cat_id: '',
                cat_name: '',
                spec: '',
                brand: '',
                video: '',
                main_pic: '',
                images: '',
                gdesc: '',
                price_min: '',
                price_min_y: '',
                price_max: '',
                order_index: '',
                sales: '',
                state: '1',
                goods_tag: '0',
                commission_rate1: '',
                commission_rate2: '',
                commission_rate3: '',
                commission_rate4: '',
                commission_tuan: '',
                share_title: '',
                share_img: '',
                share_title_act: '',
                share_img_act: '',
            },
            getObj:{
                url:'/api/admin/goods/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            imgArr: [],
            imgArr1: [],
            enu_name: ['goods_state', 'goods_tag'],
            rules: {
                title: [
                    {required: true, message: '商品名称不能为空', trigger: 'blur'}
                ],
                ftitle: [
                    {required: true, message: '商品简介不能为空', trigger: 'blur'}
                ],
                cat_id: [
                    {required: true, message: '商品所在分类不能为空', trigger: 'blur'}
                ],
                sales: [
                    {required: true, message: '销量不能为空', trigger: 'blur'},
                    {type: 'number', message: '销量必须是数字值', trigger: 'blur'}
                ],
                order_index: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                    {type: 'number', message: '排序必须是数字值', trigger: 'blur'}
                ],
                goods_tag: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                ],
                state: [
                    {required: true, message: '排序不能为空', trigger: 'blur'},
                ],
                commission_rate1: [
                    {required: true, message: '一级佣金比例不能为空', trigger: 'blur'},
                    {type: 'number', message: '一级佣金比例必须是数字值', trigger: 'blur'}
                ],
                commission_rate2: [
                    {required: true, message: '二级佣金比例不能为空', trigger: 'blur'},
                    {type: 'number', message: '二级佣金比例必须是数字值', trigger: 'blur'}
                ],
                commission_rate3: [
                    {required: true, message: '三级佣金比例不能为空', trigger: 'blur'},
                    {type: 'number', message: '三级佣金比例必须是数字值', trigger: 'blur'}
                ],
                commission_rate4: [
                    {required: true, message: '四级佣金比例不能为空', trigger: 'blur'},
                    {type: 'number', message: '四级佣金比例必须是数字值', trigger: 'blur'}
                ],
                commission_tuan: [
                    {required: true, message: '团购佣金比例不能为空', trigger: 'blur'},
                    {type: 'number', message: '团购佣金比例必须是数字值', trigger: 'blur'}
                ],
            },
            uploadAction: config.uploadAction,
            uploadData: {
                folder: "goods",
            },
            dialogImageUrl: '',
            dialogVisible: false
        };
    },
    methods: {
        loadOtherData() {
            this.imgArr = []
            this.imgArr1 = []
            this.catTree = []
            goodsCatData().then(res=>{
                if(res.code == 1){
                    this.catTree = res.data
                }
            })
        },
        formateData() {
            this.imgArr = []
            this.imgArr1 = []
            this.model.state = this.model.state+""
            this.model.goods_tag = this.model.goods_tag+""
            this.model.cat_id = this.model.cat_id+""
            if(this.$isNotNull(this.model.images)){
                let temp = JSON.parse(this.model.images)
                for (let i in temp) {
                    let tt = {name: temp[i],url: temp[i]}
                    this.imgArr.push(tt)
                }
            }
            if(this.$isNotNull(this.model.gdesc)){
                let temp1 = JSON.parse(this.model.gdesc)
                for (let i in temp1) {
                    let tt = {name: temp1[i],url: temp1[i]}
                    this.imgArr1.push(tt)
                }
            }
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    this.formateImgs();
                    let config = {
                        url:'/api/admin/goods/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        closeDialog() {
            console.log("aaa")
            this.imgArr = []
            this.imgArr1 = []
            this.$emit("on-close")
        },
        handleUploadSuccess(res, file){
            if(res.code ==1){
                let tt = {name: res.data[0],url: res.data[0]}
                this.imgArr.push(tt)
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess1(res, file){
            if(res.code ==1){
                let tt = {name: res.data[0],url: res.data[0]}
                this.imgArr1.push(tt)
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess2(res, file){
            if(res.code ==1){
                this.model.video = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess3(res, file){
            if(res.code ==1){
                this.model.share_img = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        handleUploadSuccess4(res, file){
            if(res.code ==1){
                this.model.share_img_act = res.data[0]
            }else{
                this.$msg(res.msg)
            }
        },
        formateImgs(){
            if(this.$isNotNull(this.imgArr)){
                let imgs = []
                for (const i in this.imgArr) {
                    imgs.push(this.imgArr[i].url)
                }
                this.model.images = JSON.stringify(imgs)
            }else{
                this.model.images = ''
            }
            if(this.$isNotNull(this.imgArr1)){
                let imgs = []
                for (const i in this.imgArr1) {
                    imgs.push(this.imgArr1[i].url)
                }
                this.model.gdesc = JSON.stringify(imgs)
            }else{
                this.model.gdesc = ''
            }
        },
        handleRemove(file) {
            for (const i in this.imgArr) {
                if(this.imgArr[i].url == file.url){
                    this.imgArr.splice(i,1)
                }
            }
        },
        handleRemove1(file) {
            for (const i in this.imgArr1) {
                if(this.imgArr1[i].url == file.url){
                    this.imgArr1.splice(i,1)
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        removeVideo(){
            this.model.video = ''
        }
    }
};
</script>